
export default {
  name: 'CategoryHubSkeleton',
}
